<template>
  <Button type="func" @click="handleOpen">
    <Icon v-show="isOpen" type="minimize" size="16" color="secondary" />
    <Icon v-show="!isOpen" type="maximize" size="16" color="secondary" />
  </Button>
</template>

<script>
  import Icon from '@/components/ui/Icon';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'ExpandButton',
    components: {
      Icon,
      Button,
    },
    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleOpen() {
        this.$emit('click');
      },
    },
  };
</script>
